import { ETheme } from "@/DependenciesV9";
import { NavItem, NavItemProps } from "@fluentui/react-nav-preview";

interface NavItemCustomProps {
  rcName?: string;
  theme?: ETheme;
}

const NavItemCustom = (props: NavItemProps & NavItemCustomProps) => {
  return <NavItem {...props}/>
};

export default NavItemCustom;